import { Injectable, ErrorHandler } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private isTeamsInitializationError(error: any) {
    return (
      error &&
      error.message &&
      ((error.message as string).includes('Initialization Failed. No Parent window found.') ||
        (error.message as string).includes('SDK initialization timed out.'))
    );
  }

  public handleError(error: any): void {
    if (this.isTeamsInitializationError(error)) {
      // Ignore Team initialization error
      return;
    }
    console.error(error);
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }
  }
}
